import axios from 'axios';
import cookie from 'react-cookies';

export default {
    setupInterceptors: async () => {
        await axios.interceptors.request.use(
            async config => {
                // const configuration = config;
                // if (configuration.url.indexOf('upload') > -1) {
                //   configuration.headers['Content-Type'] = 'multipart/form-data'; // eslint-disable-line
                // } else {
                //   configuration.headers['Content-Type'] = 'application/json'; // eslint-disable-line
                // }
                config.headers['Content-Type'] = 'application/json'; // eslint-disable-line
                // config.headers['Access-Key'] = 'AE698wLwHGPLvtuzF46V4P2h4yh3ru2MmkBKpsEA7bzQSHjQ3F'; // eslint-disable-line
                const token = await cookie.load('token');
                if (token && token.access_token) config.headers.Authorization = `Bearer ${token.access_token}`; // eslint-disable-line
                return config;
            },
            error => {
                Promise.reject(error);
            },
        );
        // axios.interceptors.response.use(response => response, (error) => {
        //   return Promise.reject(error.response);
        // });
    },
};
